/**
 * Generate a formatted time
 *
 * @param { number } duration - total track duration in milliseconds, e.g. 117.984
 * @returns a string of minutes:seconds formatted as 0:00 / 0:00
 */
export const formatTime = (duration) => {
    const seconds = 60;
    const minutes = Math.floor(duration / seconds);
    const remainingSeconds = Math.floor(duration % seconds);
    const padMinutesCut = 1; // 12: mins
    const padSecondsCut = 2; // :03 seconds

    return `${minutes.toString().padStart(padMinutesCut, '0')}:${remainingSeconds
        .toString()
        .padStart(padSecondsCut, '0')}`;
};
